import React from 'react';
import { useNavigate } from 'react-router-dom';

import LinkMore from '@app/components/UI/LinkMore/LinkMore';
import { useIsMobile } from '@app/hooks/useIsMobile';
import '@app/scss/components/qualityOfLife.scss';

interface DiseaseCardProps {
	name: string;
	shortText: string;
	url: string;
	topic?: string;
}

const arrowIcon = require('@app/images/arrow_circle.svg');

const DiseaseCard: React.FC<DiseaseCardProps> = ({
	name,
	shortText,
	url,
	topic,
}) => {
	const isMobile = useIsMobile();
	const navigate = useNavigate();

	return (
		<div className="quality__card" onClick={() => navigate(url)}>
			{isMobile && <div className="quality__card-bottom-topic">{topic}</div>}
			<h3 className="quality__card-title">{name}</h3>
			<p className="quality__card-text">{shortText}</p>
			<div className="quality__card-bottom">
				<LinkMore linkMoreCaption="Read more" linkMoreHref={url} />
				{!isMobile && <div className="quality__card-bottom-topic">{topic}</div>}
			</div>
		</div>
	);
};
export default DiseaseCard;
